module.exports = __webpack_public_path__ + "img/logo_black.cf77a5ed.svg";